import { render, staticRenderFns } from "./PostAdd.vue?vue&type=template&id=3def7674&scoped=true"
import script from "./PostAdd.vue?vue&type=script&lang=js"
export * from "./PostAdd.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PostAdd.vue?vue&type=style&index=1&id=3def7674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3def7674",
  null
  
)

export default component.exports